import {
  GetCardQuery_query_card_Card_tags_CardTag,
  GetCardQuery_query_card_Card_tags_CardTag_tag_Tag,
} from '../../../../../__generated__/queries-web';

export type GetCardTag = Omit<
  GetCardQuery_query_card_Card_tags_CardTag_tag_Tag,
  '__typename'
> & {
  order: number;
};
export const getCardTag = ({
  order,
  id,
  title,
  type,
}: GetCardTag): GetCardQuery_query_card_Card_tags_CardTag => ({
  __typename: 'CardTag',
  order,
  tag: {
    __typename: 'Tag',
    id,
    title,
    type,
  },
});
